


/**
 * --- External Imports ---
 */
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

/**
 * --- Internal Imports ---
 */
import { GetDocumentVerificationEvents, GetDocumentVerificationEventsResponse } from "@/apis/dtos";
import useGet from "../apis/useGet";

/**
 * --- Hook ---
 */
const getData = (response?: SWRResponse<GetDocumentVerificationEventsResponse, GetDocumentVerificationEventsResponse>) => response?.data?.verificationEvents;
const getError = (response?: SWRResponse<GetDocumentVerificationEventsResponse, GetDocumentVerificationEventsResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetDocumentVerificationEventsResponse, GetDocumentVerificationEventsResponse>) => ({});

const useGetDocumentVerificationEvents = (query?: Partial<GetDocumentVerificationEvents>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetDocumentVerificationEvents(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetDocumentVerificationEvents;